export default __webpack_public_path__ + "static/media/feature_image_3.32e91a10.webp";